import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { spaceClipAddAction, spaceClipAction, userClipAction, userClipSpaceAction, userClipInfoAction } from '../../modules/su/userInfoModule';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import SelectClipProd from '../common/button/SelectClipProd';
import SpanPrice from '../common/price/SpanPrice'
import { forEach, remove } from 'lodash';
import { setUserSpaceDelAction, setUserSpaceDelAllAction } from '../../modules/su/userSpaceModule';
import SpaceCardItem from '../st/SpaceCardItem';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MyClipSpaceBlock = styled.div`

`;

const MyClipProdHomeLinkBlock = styled.div`
    float: left;
    width: 227px;
    height: 40px;
    padding: 11px 13px 10px;
    margin-right: 8px;
    margin-left : 34px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #fff;
    //background-color: #111; //#bbb
    background-color: ${prods => prods.active ? '#111' : '#bbb'};
    cursor : ${prods => prods.active ? 'pointer' : 'default'};
    pointer-events : ${prods => prods.active ? 'auto' : 'none'};
    text-align: center;
    font-size: 14px;
    display: inline-block;
    border-radius: 4px;

    ::after {
        content: '';
        display: inline-block;
        width: 7px;
        height: 11px;
        margin-left: 10px;
        background: url(/assets/images/icon/btn_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;

const DEFAULT_DISP_CNT = 9;
const MORE_DISP_CNT = 6;

const MyClipSpace = ({ clipinfo }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [openModal, setOpenModal] = useState(false);
    const [msg, setMsg] = useState(null);
    const [spaceId, setSpaceId] = useState(null);

    const [addView, setAddView] = useState(false);
    const [scrollPostion, setScrollPostion] = useState({ heignt: 0, isClick: false });

    const { email, clipSpace, sort, spaceClipResult } = useSelector(
        ({ userReducer, userInfoReducer, userSpaceReducer }) => ({
            email: userReducer.id,
            clipSpace: userInfoReducer.clipSpace,
            spaceClipResult: userSpaceReducer.spaceClipResult,
            sort: userInfoReducer.sort,
        })
    );

    useEffect(() => {

        if (clipSpace === null && clipinfo !== null) {
            dispatch(spaceClipAction(email, 0, DEFAULT_DISP_CNT));
        }

        return () => {
        };

    }, []);

    useEffect(() => {
        if (scrollPostion.heignt > 0 && scrollPostion.isClick) {
            window.scrollTo(0, scrollPostion.heignt);
        }
        if (clipSpace !== null && clipinfo !== null) {
            let count = clipinfo.spaceCount;
/*             if(defaultValueProduct.brnd_id === 0){
                for(var i = 0; i < clipinfo.prodbrand.length ; i++){
                    count += clipinfo.prodbrand[i].countprdt;
                }
            }
            else {
                let index = clipinfo.prodbrand.findIndex(x => x.brnd_id === defaultValueProduct.brnd_id);
                count += clipinfo.prodbrand[index].countprdt;
            } */

            if (clipSpace.length < count) {
                setAddView(true);
            }
            else {
                setAddView(false);
            }
        }
        setScrollPostion({ heignt: 0, isClick: false });

        return () => {
        };

    }, [clipSpace]);

    useEffect(() => {

        if(spaceClipResult){
            if (msg === '삭제하시겠습니까?') {
                let count = clipinfo.spaceCount - 1;

                if(count === 0){
                    dispatch(userClipAction('sort=' + sort));
                }
                else {
                    //clipinfo.prodbrand[index].countprdt = count;
                    let clipSum = [...clipSpace];
                    remove(clipSum, (obj) => { return obj.st_id === spaceId })
                    let clip = Object.assign({}, clipinfo);
                    clip.spaceCount = count;
                    dispatch(userClipSpaceAction(clipSum));
                    dispatch(userClipInfoAction(clip));
                }
                setMsg(null);
            } else if(msg === '전체 삭제하시겠습니까?'){
                    dispatch(userClipAction('sort=' + sort));
                    setMsg(null);
            }
        }

        return () => {
        };

    }, [spaceClipResult]);

    const onClickAddView = () => {
        //dispatch(getBrandInfoAction(BrFilterList[index].value,"0","0"));
        let count = clipinfo.spaceCount;

        if (count > clipSpace.length) {
            dispatch(spaceClipAddAction(email, clipSpace.length, MORE_DISP_CNT));
        }

        setScrollPostion({ heignt: window.scrollY, isClick: true });
    }

    const getNoSpaceContents = () => {
        return (
            <div className="none_item">
                <span style={{width:'fit-content'}}>내가 클립한 공간 투어가 없어요 :-(</span>
            </div>
        )
    }

    const handleClickSpace = (space_id) => {
        history.push("/stdetail?id=" + space_id);
    }

    // 컨텐츠 정보
    const getSpaceContents = (target) => {

        if (target.length === 0) {
            return getNoSpaceContents();
        } else {
            return (
                <div className="margin_t-30">
                    {isMobileOnly ?
                        <div className="scroll_item-wrap mp_con-list margin_b-40 clearfix"
                            style = {{margin:"-30px auto", height: 'auto'}}>
                        {
                            target.map((curitem, index) => {
                                return (
                                    <div className="si-list_item" style = {{width: '45vw', marginLeft: '1vw', height:"50vw"}}>
                                        <button type="button" class="tag_s-delete pop_open" onClick={() => { handleClickDelBtn(curitem.st_id) }}></button>
                                        <SpaceCardItem
                                            width={"auto"}
                                            key={curitem.st_id}
                                            iteminfo={curitem}
                                            paddingLeft={"0px"}
                                            paddingTop={"0px"}
                                            height={"50vw"}
                                            />
                                    </div>
                                )
                            })
                        }
                        </div>
                    :
                        <div className="scroll_item-wrap mp_con-list margin_b-40 clearfix">
                        {
                            target.map((curitem, index) => {
                                    return (
                                        <div className="si-list_item">
                                            <button type="button" class="tag_s-delete pop_open" onClick={() => { handleClickDelBtn(curitem.st_id) }}></button>
                                            <SpaceCardItem
                                                width={"292px"}
                                                key={curitem.st_id}
                                                iteminfo={curitem}
                                                paddingLeft={"0px"}
                                                paddingTop={"0px"}
                                                height={"337px"}
                                                isMyClip={true}
                                                />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }

                {
                    addView === false ? '' :
                        <div className="text_center">
                            <button className="underline-btn" onClick={onClickAddView}>더보기</button>
                        </div>
                }
            </div >)
        }
    }

    const handleAllDelete = () => {
        setMsg("전체 삭제하시겠습니까?");
        // 팝업 표시
        setOpenModal(true);
    }

    // Delete 처리
    const handleClickDelBtn = (spaceid) => {
        setMsg("삭제하시겠습니까?");
        setOpenModal(true);
        setSpaceId(spaceid);
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 확인
    const handleModalBtn1Click = () => {
        setOpenModal(false);
        if (msg === '삭제하시겠습니까?') {
            dispatch(setUserSpaceDelAction(email, spaceId));

        } else {
            dispatch(setUserSpaceDelAllAction(email));
        }
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    if(clipinfo === null || clipSpace === null || clipSpace === undefined){
        return <div/>
    }

    if(clipinfo !== null && clipSpace !== null && clipSpace.length === 0){
        return getNoSpaceContents();
    }
    return (
        <MyClipSpaceBlock>

            <div className="filter-top border_none clearfix">
                <div className="f-right clearfix">
                    <button type="button" className="mp_text-btn f-left margin_t-10 pop_open" style={{ marginTop: '20px' }}
                        onClick={handleAllDelete}>전체삭제</button>
                </div>
            </div>
            {getSpaceContents(clipSpace)}
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    <NormalPopup
                        text=""
                        text2={msg}
                        btn1="확인" btn2="취소"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
                }

            </Modal>

        </MyClipSpaceBlock>
    );
};

export default MyClipSpace;
